'use client'

// Hook Imports
import useVerticalNav from '@menu/hooks/useVerticalNav'
// Logo image with "iTaxPro" text below in orange (sidebar & shared use)

const Logo = ({ color }) => {
  // Hooks
  const { isCollapsed, isHovered } = useVerticalNav()

  return (
    <div className={`flex flex-row items-center ${isCollapsed && !isHovered ? 'justify-center' : 'justify-start'} gap-2 min-bs-[24px]`}>
      <img
        src='/logo.jpeg'
        alt='iTaxPro'
        className={isCollapsed && !isHovered ? 'h-10 w-auto object-contain' : 'h-16 w-auto max-w-[220px] object-contain block shrink-0'}
      />
      {(!isCollapsed || isHovered) && (
        <span
          className='text-lg font-semibold tracking-tight whitespace-nowrap'
          style={{ color: color ?? '#ed6c02' }}
        >
          iTaxPro
        </span>
      )}
    </div>
  )
}

export default Logo
